import { BaseApiService } from './baseApi';
import type { ApiResponse } from '../../../../types';

export interface DashboardStats {
  totalProjects: number;
  academicProjects: number;
  professionalProjects: number;
  projectsWithLinks: number;
  completionRate: number;
  totalSections: number;
  visibleSections: number;
  hiddenSections: number;
  visibilityRate: number;
  totalEducation: number;
  totalHobbies: number;
  aboutConfigured: boolean;
  aboutCompletionScore: number;
  overallHealth: number;
  lastUpdated: string;
}

export class SystemApiService extends BaseApiService {
  constructor() {
    super('/stats');
  }

  /**
   * Validate la santé de l'API SANS authentification
   */
  async healthCheck(): Promise<boolean> {
    try {
      const response = await this.requestGet<any>('/health', false);
      return response.success;
    } catch (error) {
      return false;
    }
  }

  /**
   * Get les statistiques du dashboard (AVEC authentification)
   */
  async getDashboardStats(): Promise<ApiResponse<DashboardStats>> {
    return this.requestGet<DashboardStats>('/dashboard', true);
  }

  /**
   * Get les statistiques détaillées des projets
   */
  async getProjectStats(): Promise<ApiResponse<any>> {
    return this.requestGet<any>('/projects', true);
  }

  /**
   * Get le rapport de santé globale (AVEC authentification)
   */
  async getHealthReport(): Promise<ApiResponse<any>> {
    return this.requestGet<any>('/health-report', true);
  }
}

export const systemApi = new SystemApiService();
